import type { Dispatch } from 'redux';
import type { Persistor } from 'redux-persist';

import { sessionActions } from '../ducks/session';
import { resetWialonApi } from './api/wialon';
import tokenManager from './tokenManager';

type TokenManager = Pick<typeof tokenManager, 'clearToken'>;
type SessionPersistor = Pick<
  Persistor,
  'pause' | 'flush' | 'purge' | 'persist'
>;

type SessionTeardownDependencies = {
  dispatch: Dispatch;
  persistor: SessionPersistor;
  token?: TokenManager;
  resetWialon?: () => Promise<void>;
};

let pending: Promise<void> | null = null;

export const createSessionTeardown = ({
  dispatch,
  persistor,
  token = tokenManager,
  resetWialon = resetWialonApi
}: SessionTeardownDependencies) => {
  const teardown = async (): Promise<void> => {
    if (pending) return pending;

    pending = (async () => {
      persistor.pause();
      try {
        await resetWialon();
      } catch (error) {
        console.error('Wialon session teardown failed', error);
      } finally {
        token.clearToken();
        dispatch(sessionActions.reset());
        await persistor.flush();
        await persistor.purge();
        persistor.persist();
      }
    })().finally(() => {
      pending = null;
    });

    return pending;
  };

  return teardown;
};
